import PropTypes from 'prop-types';
// @mui
import { TableRow, TableCell, Checkbox, Typography, Box, Chip } from '@mui/material';
// components
import Iconify from 'src/components/iconify';
import { destinationDeliveryOf } from 'src/utils/physical-api';

// ----------------------------------------------------------------------

export default function GeorgianPhysicalPaymentTableRow({ row, selected, onSelectRow, onViewRow }) {
  const {
    trackingNumbers,
    totalWeight,
    pickup_area,
    pickup_price,
    promotion,
    totalUSD,
    totalGel,
    payed_by,
    paymentMethod,
    deliveryGEL,
    deliveryUSD,
    payed,
    createdAt,
    updatedAt,
  } = row;

  const getStatusColor = (status) => (status ? 'success' : 'warning');

  const getPaymentMethodIcon = (method) => {
    switch (method) {
      case 'USD':
        return '💵';
      case 'GEL':
        return '💸';
      default:
        return '💰';
    }
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('ka-GE');
  };

  const formatNumber = (num) => {
    if (num == null || num === undefined) return 'N/A';
    return Number(num).toFixed(2);
  };

  const formatDeliveryMethod = (method) => {
    if (!method) return 'N/A';
    return method.replace(/_/g, ' ');
  };

  const formatPaymentMethod = (method) => {
    if (!method) return 'N/A';
    return method.replace(/_/g, ' ');
  };

  return (
    <TableRow
      hover
      selected={selected}
      onClick={() => onViewRow()}
      sx={{
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
    >
      <TableCell padding="checkbox" onClick={(e) => e.stopPropagation()}>
        <Checkbox checked={selected} onChecked={onSelectRow} />
      </TableCell>

      <TableCell>
        <Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
          {trackingNumbers || 'N/A'}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" noWrap>
          {totalWeight ? `${totalWeight} kg` : 'N/A'}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" noWrap>
          {pickup_area || 'N/A'}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" noWrap>
          {pickup_price != null ? `₾${formatNumber(pickup_price)}` : 'N/A'}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" noWrap>
          {promotion != null ? `₾${formatNumber(promotion)}` : 'N/A'}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" noWrap color="primary">
          ${formatNumber(totalUSD)}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" noWrap color="secondary">
          {formatNumber(totalGel)} ₾
        </Typography>
      </TableCell>

      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography>{getPaymentMethodIcon(payed_by)}</Typography>
          <Typography variant="body" noWrap>
            {payed_by || 'N/A'}
          </Typography>
        </Box>
      </TableCell>

      <TableCell>
        <Typography variant="body2" noWrap>
          {formatPaymentMethod(paymentMethod)}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" noWrap>
          {formatDeliveryMethod(destinationDeliveryOf(row.orders[0]))}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" noWrap>
          {deliveryGEL != null ? `₾${formatNumber(deliveryGEL)}` : 'N/A'}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" noWrap>
          {deliveryUSD != null ? `$${formatNumber(deliveryUSD)}` : 'N/A'}
        </Typography>
      </TableCell>

      <TableCell>
        <Chip
          label={payed ? 'Paid' : 'Unpaid'}
          color={getStatusColor(payed)}
          variant="filled"
          size="small"
        />
      </TableCell>

      <TableCell>
        <Typography variant="body2" noWrap>
          {formatDate(createdAt)}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body2" noWrap>
          {formatDate(updatedAt)}
        </Typography>
      </TableCell>

      <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
        <Iconify icon="solar:eye-bold" sx={{ color: 'text.secondary' }} />
      </TableCell>
    </TableRow>
  );
}

GeorgianPhysicalPaymentTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
  onSelectRow: PropTypes.func,
  onViewRow: PropTypes.func,
};
